module.exports = __webpack_public_path__ + "static/media/290527.a261a5d1.png";